import React from 'react'

import Menu from './menu/menu'
import FieldsList from './fields-list'
import FieldProto from "../../../../fields3/proto/field-proto"
import Search from "../../../../gd-components/search/search";
import {FieldSelectorConfig} from "../convert-fields-structure";

let selectedSection: any = null

export type PopoverAddColumnProps = {
    config                  : FieldSelectorConfig

    fields                  : FieldProto[]
    columns?                : any[]
    selectedFieldIds        : ID[]
    mandatoryColumnsIds?    : ID[]

    noValueOption?          : Option
    isAddVisible            : boolean
    showModifierOptions?    : boolean   // show additional options for fields (i.e. interval for Date fields)
    hideEmptyCustomFields?  : boolean   // hide custom fields group if it has no items

    hidePopover             : callback
    onToggleColumn          : {(fieldId: ID | null, params?: any, field?: FieldProto): void}
    onNewCustomField        : callback
}

type State = {
    section     : any
    searchQuery : string
}

export default class PopoverAddColumn extends React.Component<PopoverAddColumnProps, State> {

    constructor(props:PopoverAddColumnProps) {
        super(props);

        const section = selectedSection && !!_.find(this.props.config.groupedFields, g=>g.value === selectedSection) ? selectedSection : this.props.config.groupedFields[0].value //group.groupId or new-field

        this.state = {
            section     : section,
            searchQuery : ""
        };
    }

    onSelectSection = (section:string) => {
        switch (section) {
            case 'none':
                this.props.hidePopover()
                this.props.onToggleColumn(null)
                return

            case 'new-field':
                const company = gd.session.companies.get(gd.companyId)
                this.props.hidePopover()

                if (!company.license.customFields) {
                    gd.modals.other.upgradeToPro(gd.companyId)
                } else {
                    this.props.onNewCustomField()
                }
                return
        }

        selectedSection = section;

        this.setState({
            section: section
        })
    }

    onChangeSearchQuery = (query: string)=> {
        this.setState({searchQuery:query})
    }

    onClearSearchQuery = ()=> {
        this.setState({searchQuery: ""})
    }

    render() {
        const SearchComponent =
            <Search
                className           = "m-l-10 m-r-10 m-b-15"
                value               = {this.state.searchQuery}
                onChange            = {this.onChangeSearchQuery}
                clearSearchValue    = {this.onClearSearchQuery}
            />

        return (
            <div className="main">
                <Menu
                    section                 = {this.state.section}
                    searchQuery             = {this.state.searchQuery}
                    searchComponent         = {SearchComponent}
                    isAddVisible            = {this.props.isAddVisible}
                    config                  = {this.props.config}
                    hideEmptyCustomFields   = {this.props.hideEmptyCustomFields}
                    // addedColumnsIds         = {this.props.addedColumnsIds}
                    noValueOption           = {this.props.noValueOption}
                    onSelectSection         = {this.onSelectSection}
                />

                <FieldsList
                    section         = {this.state.section}
                    columns         = {this.props.columns}
                    searchQuery     = {this.state.searchQuery}
                    onSelectSection = {this.onSelectSection}
                    {...this.props}
                />
            </div>
        )
    }
}
